import axios from "axios"
import { getToken, VERSION_NO } from "./utils.actions"

export const enableMeetingPayments = (enableMeetingPayments) => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/enableMeetingPayments?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            enable: enableMeetingPayments,
            "adminDocterId": userData?.adminDocterId || 0,
        })
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const linkStripe = () => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/linkStripeAccount?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            "adminDocterId": userData?.adminDocterId || 0,
            "isFromMeeting": 1
        })
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const unLinkStripe = () => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/unlinkStripeAccount?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            "adminDocterId": userData?.adminDocterId || 0,
            "isFromMeeting": 1
        })
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const getStripeDetails = () => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/getMeetingPrice?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}&adminDocterId=${userData?.adminDocterId}`)
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}
export const updateProviderFee = (price) => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/updateMeetingPrice?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            "adminDocterId": userData?.adminDocterId || 0,
            price
        })
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const getProviderSubscriptionSummary = () => async (dispatch, getState) => {

    try {
        const userData = getState().auth?.UserData
        const res = await axios.get(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/ProviderSubscriptionSummary?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}&clinicGroupItemId=${userData?.ClinicGroupItem?.clinicGroupItemId}&versionId=1643264959`)
        return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const firstSubscription = () => async (dispatch, getState) => {
  
    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/create-checkout-session?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            "paymentFrequency": "monthly",
            "docId": getState().auth?.UserData?.adminDocterId || 0,
            "qty": 1,
            "isFromMeeting": true
        })
       return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}

export const updateProviderCount = (providerCount) => async (dispatch, getState) => {
  
    try {
        const userData = getState().auth?.UserData
        const res = await axios.post(getState().utils.baseURL + `/PT2/httpdocs/${VERSION_NO}/updateProviderCount/${userData.adminDocterId}/health001~${userData.passcodeID1}/token=${getToken(getState)}?doctorIdParam=${userData.adminDocterId}&passcode=health001~${userData.passcodeID1}&token=${getToken(getState)}`, {
            providerCount: 2,
            "adminDocterId": userData.adminDocterId || 0,
            "clinicGroupItemId": userData.ClinicGroupItem?.clinicGroupItemId || 0,
        })
       return res;
    } catch (error) {
        console.log(error)
        return { status: false, msg: "Something failed, please try again later" }
    }

}